import React from "react";
import { useNavigate } from "react-router-dom";

interface AddButtonProps {
  label?: string;
  to?: string;
  onClick?: any;
  className?: string;
}

const AddButton: React.FC<AddButtonProps> = ({
  label = "Add Lead",
  to = "/",
  onClick,
  className = "",
}) => {
  const navigate = useNavigate();

  const handleClick = () => {
    if (onClick) {
      onClick();
    } else {
      navigate(to);
    }
  };

  return (
    <button
      onClick={handleClick}
      className={`bg-customOrange hover:bg-greenBg text-white text-sm font-semibold px-4 py-1.5 rounded-md flex items-center space-x-1 ease-in-out duration-500 shadow-[1px_2px_2px_rgba(0,0,0,0.3)] ${className}`}
    >
      <span>+</span>
      <span>{label}</span>
    </button>
  );
};

export default AddButton;
